<app-efa-sub-list>
  <a actions class="link" routerLink="assign">
    {{ 'organization.assign' | cxTranslate }}
  </a>
</app-efa-sub-list>
